import React from 'react'
import { Navigate } from 'react-router-dom'
import PropTypes from 'prop-types'

import { APP_ROUTES } from '../../../common/constants'

import { useUserHasPermissions } from '../../hooks'
import { permissionsPropType } from '../../prop-types'

const PermissionRedirect = ({ permissions, children }) => {
  const hasPermission = useUserHasPermissions(permissions)

  return hasPermission ? (
    children
  ) : (
    <Navigate to={APP_ROUTES.ACCOUNT.children.LOGIN.fullPath} replace />
  )
}

PermissionRedirect.propTypes = {
  permissions: permissionsPropType.isRequired,
  children: PropTypes.node.isRequired,
}

export default PermissionRedirect
